import { render, staticRenderFns } from "./2021-1-1.vue?vue&type=template&id=d00c2e44&scoped=true&"
import script from "./2021-1-1.vue?vue&type=script&lang=ts&"
export * from "./2021-1-1.vue?vue&type=script&lang=ts&"
import style0 from "./2021-1-1.vue?vue&type=style&index=0&id=d00c2e44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d00c2e44",
  null
  
)

export default component.exports